import logo from "../assets/logo.png";
const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-20 pb-8 mt-20">
      <div className="absolute top-0 left-0 w-full">
        <svg
          viewBox="0 0 1440 120"
          className="w-full h-20 fill-gray-900 transform rotate-180"
        >
          <path d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      </div>

      <div className="absolute top-20 left-10 text-5xl opacity-10 animate-bounce">
        🐱
      </div>
      <div className="absolute top-40 right-20 text-5xl opacity-10 animate-pulse">
        ⭐
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-14 h-14 bg-gradient-to-br bg-white rounded-full flex items-center justify-center shadow-lg">
                <img
                  src={logo}
                  alt="Little Winners"
                  className="w-15 h-14 object-cover "
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">Little Winners</h3>
                <p className="text-sm text-yellow-400 font-semibold">
                  Oyun Evi & Cafe
                </p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Little Winners Merkezi'ni ziyaret edin.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold text-yellow-400 mb-4">İletişim</h4>
            <ul className="space-y-2 text-gray-400">
              <li>📍Şehitlik, Boztepe Cd. NO:52, 06900 Polatlı/Ankara</li>
              <li>📞 +90 533 449 90 39</li>
              <li>✉️ littlewinners06@gmail.com</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold text-yellow-400 mb-4">Galeri</h4>
            <div className="grid grid-cols-3 gap-2">
              {["📸", "🎨", "🎂", "⚽", "📚", "🎭"].map((emoji, index) => (
                <div
                  key={index}
                  className="aspect-square bg-white/10 rounded-lg flex items-center justify-center text-2xl hover:bg-white/20 transition-all cursor-pointer"
                >
                  {emoji}
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xl font-bold text-yellow-400 mb-4">
              Çalışma Saatleri
            </h4>
            <div className="space-y-2">
              {[
                { day: "Salı - Pazar", time: "11:00 - 21:30" },
                { day: "Pazartesi", time: "Kapalı" },
              ].map((hour, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2 border-b border-gray-700 text-sm"
                >
                  <span className="text-gray-400">{hour.day}</span>
                  <span className="text-yellow-400 font-bold">{hour.time}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-3 mt-6">
              <a
                href="https://instagram.com/littlewinners06"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:-translate-y-1 transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="w-6 h-6"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10z" />
                  <path d="M12 7a5 5 0 100 10 5 5 0 000-10zm0 2.2a2.8 2.8 0 110 5.6 2.8 2.8 0 010-5.6z" />
                  <circle cx="17.5" cy="6.5" r="0.8" />
                </svg>
              </a>

              <a
                href="https://wa.me/905334499039"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:-translate-y-1 transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="w-6 h-6"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M20.52 3.48A11.88 11.88 0 0012 .25 11.9 11.9 0 003.48 3.48C1.42 6.54 1 10.63 2.33 14.31L2 21l6.9-.33c3.68 1.32 7.77.9 10.83-1.16A11.9 11.9 0 0024 12c0-1.92-.44-3.84-1.48-5.52zM12 21c-1.18 0-2.36-.14-3.47-.42l-.25-.07-4.12.2.43-3.97-.11-.27A8.01 8.01 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 3.69-2.57 6.82-6 7.68A7.9 7.9 0 0112 21z" />
                  <path d="M17.56 14.86c-.28-.14-1.66-.82-1.92-.91-.26-.09-.45-.14-.64.14-.18.28-.7.91-.86 1.1-.15.18-.3.2-.58.07-.28-.14-1.18-.43-2.25-1.39-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.12-.12.28-.31.42-.47.14-.16.18-.28.28-.47.09-.18.05-.35-.02-.49-.07-.14-.64-1.54-.88-2.11-.23-.56-.47-.48-.64-.49l-.55-.01c-.18 0-.47.07-.72.34-.25.28-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.14.18 1.93 3.04 4.68 4.26 3.25 1.44 3.25 0 3.84-.05.6-.06 1.9-.77 2.17-1.51.28-.75.28-1.39.2-1.51-.07-.12-.26-.18-.54-.32z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700 text-center text-gray-500">
          <p>&copy; 2025 LittleWinners. Tüm hakları saklıdır. ❤️</p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
